// @flow
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import owlImage from 'assets/images/parent_owl.svg';
import ribbonImage from 'assets/images/parent_ribbon.png';
import kidOwl from 'assets/images/kid_owl.svg';
import teenOwl from 'assets/images/teen_owl.svg';
import { getColor } from 'utils/color';

const FamilyMemberItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #d2d2d2;
  padding: 11px 0;
`;

const FamilyMember = styled.div`
  display: flex;
  flex-direction: row;
  max-height: 90px;
  min-width: 100px;
  cursor: pointer;
`;

const FamilyMemberAvatar = styled.div`
  background-color: #09798D;
  width: 75px;
  height: 60px;
  border-radius: 50%;
  margin-right: 30px;
  background-color: ${(props) => `#${props.color}`}
`;

const AvatarImage = styled.img`
  border-radius: ${(props) => (props.hasProfilePicture ? '50%;' : '0%')}; 
  margin: ${(props) => (props.hasProfilePicture ? '0px' : '8px')};
  max-width: ${(props) => (props.hasProfilePicture ? '60px' : '45px')};
  width: ${(props) => (props.hasProfilePicture ? '60px' : '45px')};
  ${(props) => (props.hasProfilePicture ? 'height: 60px;' : '')}
  ${(props) => (props.hasProfilePicture ? 'object-fit: cover;' : '')}
`;

const AvatarRibbonContainer = styled.div`
  display: ${(props) => (props.type === 'Parent' ? 'block' : 'none')};
  position: absolute;
  margin-top: -5px;
`;

const AvatarRibbon = styled.img`
  vertical-align: middle;
`;

const FamilyMemberInfo = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;

`;

const FamilyMemberName = styled.div`
  font-family: "Avenir Next LT W01 Demi";
  font-size: 16px;
  color: #000;
  text-align: left;
  width: 90%;
  vertical-align: middle;
  margin-top: 10px;
`;

const FamilyMemberUsername = styled.div`
  font-family: "AvenirNextLTW01-Regular";
  font-weight: 100;
  font-size: 15px;
  color: #A9A9A9;
  margin-top: 7px;
  align-self: flex-start;
`;

const FamilyMemberChildContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding-left: 20%;
  margin-top: 10px;
  cursor: pointer;
`;

const FamilyMemberChildAvatarContainer = styled.div`
  min-width: 40px;
  margin-right: 15px;
  overflow: hidden;
  border-radius: 50%;
  height: 40px !important;
  background-color: ${(props) => `#${props.color}`}
`;

const FamilyMemberChildAvatar = styled.img`
  display: inline-block;
  border-radius: 0% !important;
  margin: ${(props) => (props.hasProfilePicture ? '0px' : '5px 5px')};
  width: ${(props) => (props.hasProfilePicture ? '45px' : '30px')};
  height: ${(props) => (props.hasProfilePicture ? '45px' : '30px')};
`;

const FamilyMemberChildInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const FamilyMemberChildName = styled.div`
  display: flex;
  font-family: "Avenir Next LT W01 Demi";
  font-size: 16px;
  color: #000;
  text-align: left;
  width: 100%;
  vertical-align: middle;
  margin-top: 4px;
`;
type ChildOfParentTextProps = {
  isKid: boolean,
  parentFullName: string,
}
const FamilyMemberChildOfParent = ({ isKid, parentFullName }: ChildOfParentTextProps) => (
  <>
    { (isKid && parentFullName) && (
      <span>
        {' '}
        {`| Child of ${parentFullName}`}
        {' '}
      </span>
    )}
  </>
);

const FamilyMemberChildOfParentText = styled.span`
  font-family: "Avenir Next LT W01 Demi";
  font-size: 16px;
  color: gray;
  text-align: left;
  width: 100%;
  margin-top:10px;
  line-height: 1.3;
`;

const FamilyMemberChildUsername = styled.div`
  font-family: "AvenirNextLTW01-Regular";
  font-weight: 100;
  font-size: 15px;
  color: #A9A9A9;
  margin-top: 7px;
  align-self: flex-start;
`;

const StyledLink = styled(Link)`
    text-decoration: none;

    &:focus, &:hover, &:visited, &:link, &:active {
        text-decoration: none;
    }
`;

type FamilyMemberProps = {
  rid: string,
  fullName: string,
  userName: string,
  userType: string,
  profileImageUrl: string,
}

type FamilyMemberContainerProps = {
  familyMember: FamilyMemberProps,
  familyMemberChilds: Array<FamilyMemberProps>,
  color: string,
  onSelect: Function,
  query: string
};

const getImageForFamilyMember = (familyMember) => {
  const result = { hasProfileImage: false, image: '' };
  const isKid = familyMember.userType !== 'Parent';
  const { isTeen } = familyMember;

  if (familyMember.profileImageUrl && familyMember.profileImageUrl !== '') {
    if (isTeen || isKid === false) {
      result.image = familyMember.profileImageUrl;
      result.hasProfileImage = true;
    } else if (isKid) {
      result.image = kidOwl;
    }
  } else if (isKid && isTeen === false) {
    result.image = kidOwl;
  } else if (isKid && isTeen) {
    result.image = teenOwl;
  } else { result.image = owlImage; }

  return result;
};

const LoadFamilyMemberChilds = (members, onSelect, queryUserNameCharacter) => {
  if (members && members.length > 0) {
    return members.map((member, index) => {
      const imageMember = getImageForFamilyMember(member);

      const { image } = imageMember;
      const hasProfilePicture = imageMember.hasProfileImage;

      return (
        <FamilyMemberChildContainer onClick={() => onSelect(member)} key={member.rid}>
          <FamilyMemberChildAvatarContainer color={getColor(index + 1)}>
            <FamilyMemberChildAvatar hasProfilePicture={hasProfilePicture} src={image} />
          </FamilyMemberChildAvatarContainer>
          <FamilyMemberChildInfoContainer>
            <FamilyMemberChildName>
              {member.fullName}
            </FamilyMemberChildName>
            <FamilyMemberChildUsername>
              {`${queryUserNameCharacter}${member.userName}`}
            </FamilyMemberChildUsername>
          </FamilyMemberChildInfoContainer>
        </FamilyMemberChildContainer>
      );
    });
  }

  return <></>;
};

const FamilyMemberContainer = (props: FamilyMemberContainerProps) => {
  const {
    familyMember, familyMemberChilds, color, onSelect, query,
  } = props;
  const imageMember = getImageForFamilyMember(familyMember);

  let queryUserNameCharacter = '@';
  queryUserNameCharacter = query.includes('$') ? '$' : queryUserNameCharacter;

  const { image } = imageMember;
  const hasProfilePicture = imageMember.hasProfileImage;

  return (
    <FamilyMemberItemContainer>
      <FamilyMember onClick={() => onSelect(familyMember)}>
        <FamilyMemberAvatar color={color}>
          <AvatarImage hasProfilePicture={hasProfilePicture} src={image} />
          <AvatarRibbonContainer type={familyMember.userType}>
            <AvatarRibbon src={ribbonImage} />
          </AvatarRibbonContainer>
        </FamilyMemberAvatar>
        <FamilyMemberInfo>
          <FamilyMemberName>
            {familyMember.fullName}
            <FamilyMemberUsername>
              {`${queryUserNameCharacter}${familyMember.userName}`}
            </FamilyMemberUsername>

          </FamilyMemberName>
          {/* <FamilyMemberChildOfParentText>
            <FamilyMemberChildOfParent
              isKid={familyMember.userType === 'Kid'}
              parentFullName={familyMember.parentFullName}
            />
          </FamilyMemberChildOfParentText> */}
        </FamilyMemberInfo>
      </FamilyMember>
      {LoadFamilyMemberChilds(familyMemberChilds, onSelect, queryUserNameCharacter)}
    </FamilyMemberItemContainer>
  );
};

export default FamilyMemberContainer;
